(() => {
  'use strict';

  const VERSION = '11.87';
  const api = window.AONSK_INTEGRATED_PLANNERS;
  const Planner = api?.__test?.GardenPlanner;
  if (!Planner || Planner.prototype.__aonsk1187) return;
  const proto = Planner.prototype;
  proto.__aonsk1187 = true;

  function ensure(planner) {
    planner.state.version = VERSION;
  }

  function editorialGuide() {
    return `<section class="aonsk-editorial-guide" aria-labelledby="aonsk-bed-guide-title">
      <div class="aonsk-editorial-guide__intro">
        <p class="aonsk-edu-eyebrow">A simpler path</p>
        <h3 id="aonsk-bed-guide-title">Describe the bed first. Add detail only when it helps.</h3>
        <p>Bed basics and soil stay easy to find. Open water, microclimate, pest, or laboratory details only when they apply.</p>
      </div>
      <ol aria-label="Grow Location information order">
        <li class="is-site"><span>1</span><div><strong>Grow Location</strong><small>Size, sun, support</small></div></li>
        <li class="is-soil"><span>2</span><div><strong>Soil</strong><small>Observation or test</small></div></li>
        <li class="is-water"><span>3</span><div><strong>Water</strong><small>Source and capacity</small></div></li>
        <li class="is-observation"><span>4</span><div><strong>Local notes</strong><small>Weather, pests, patterns</small></div></li>
      </ol>
      <p class="aonsk-editorial-guide__source"><strong>Keep the sources separate:</strong> mapped soil and NOAA normals provide regional context; a soil test and dated rain-gauge entry describe the conditions you actually measured. A forecast is not connected.</p>
    </section>`;
  }

  const baseRender = proto.render;
  proto.render = function () {
    ensure(this);
    const result = baseRender.call(this);
    ensure(this);
    const app = this.root.querySelector('.aonsk-planner-app');
    if (app) {
      app.classList.add('aonsk-planner-app--v1187');
      app.dataset.editorialStep = String((Number(this.step) || 0) + 1);
    }
    return result;
  };

  const baseStepSpaces = proto.stepSpaces;
  proto.stepSpaces = function () {
    return baseStepSpaces.call(this)
      .replace(/<section class="aonsk-input-map"[\s\S]*?<\/section>/, editorialGuide())
      .replace('Start with the visible bed essentials and soil section. Open the colored water, microclimate, pest, or advanced-report panels only when they apply; unknown and no-irrigation answers remain valid.', 'Enter the essentials first. The optional panels keep advanced soil, water, microclimate, pest, and seasonal information close by without putting everything on screen at once.');
  };

  window.AONSK_GARDEN_BUILDER_1187 = { version: VERSION, editorialGuide };
  const refresh = () => document.querySelector('[data-planner-page="garden"] [data-planner-step].is-active')?.click();
  queueMicrotask(refresh);
  setTimeout(refresh, 0);
})();
